import cmp from './InactiveAccount'

export default cmp
